import script from "./AdventureChatMultiplayer.vue?vue&type=script&setup=true&lang=js"
export * from "./AdventureChatMultiplayer.vue?vue&type=script&setup=true&lang=js"

import "./AdventureChatMultiplayer.vue?vue&type=style&index=0&id=7ed85337&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ed85337"]])

export default __exports__